import { sIsValidPostcode } from '../../shared.min.js';
import { sInputKeyValidationHelper } from '../../shared.min.js';

const bluebadges = (function () {
	let widget,
		mapElement,
		postcode,
		fieldGroup,
		errorMessageElement,
		postCodeErrors,
		postCodeValid,
		geoLocate,
		getResultsButton,
		currentLocationData,
		currentLocationMarker,
		markers = [],
		results,
		changePostcode,
		infoElement,
		infoContents,
		closeInfo,
		parkingSvgString,
		graphLabelSpaces,
		graphLabelHolders,
		graphBarSpaces,
		graphBarHolders,
		totalSpaces,
		totalHolders,
		graphDifference,
		searchHereElement,
		searchHereButton,
		postCodeLookupUrl,
		completeData;

	// Initialize the blue badges widget
	const init = () => {
		((widget = document.querySelector('.blue-badge__container')),
			(mapElement = widget.querySelector('#map')),
			(searchHereElement = widget.querySelector('.blue-badge__search-here')),
			(searchHereButton = widget.querySelector('#searchHereButton')),
			(postcode = widget.querySelector('#bbMapPostcode')),
			(fieldGroup = postcode.closest('.field-group')),
			(errorMessageElement = fieldGroup.querySelector('.error-message')),
			(geoLocate = widget.querySelector('#useGeoLocation')),
			(getResultsButton = widget.querySelector('#getResults')),
			(postCodeErrors = {
				empty: postcode.getAttribute('data-error-empty'),
				tooShort: postcode.getAttribute('data-error-too-short'),
				tooLong: postcode.getAttribute('data-error-too-long'),
				invalidFormat: postcode.getAttribute('data-error-invalid-format'),
			}),
			(infoElement = document.querySelector('.blue-badge__details-drawer')),
			(infoContents = document.getElementById('locationDetails')),
			(closeInfo = infoElement.querySelector('.blue-badge__details-close')),
			(results = document.querySelector('.blue-badge__results')),
			(changePostcode = results.querySelector('.blue-badge__change-postcode')),
			(graphLabelSpaces = results.querySelector('#graphLabelSpaces')),
			(graphLabelHolders = results.querySelector('#graphLabelHolders')),
			(graphBarSpaces = results.querySelector('#graphBarSpaces')),
			(graphBarHolders = results.querySelector('#graphBarHolders')),
			(graphDifference = results.querySelector('#graphDifference')),
			(parkingSvgString = `
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 43"><path fill="#015FDB" d="M30 15.174c-.004-.472.01-.945-.017-1.416l-.046.005a6.226 6.226 0 0 0-.009-.617l-.115.074c.112-.148.06-.339.06-.509l-.052.009c.002-.108.003-.215.002-.322l-.128.05c.087-.092.07-.22.076-.333l-.066.035c.001-.103.004-.206.004-.309l-.055.01c.006-.19-.05-.374-.103-.554-.021-.08-.042-.157-.068-.233a15.866 15.866 0 0 1-.006-.166l-.052.031c-.01-.152-.048-.3-.08-.447l-.128.05.113-.2-.09.02.003-.203-.065.026.01-.187-.053.006c-.017-.107-.047-.211-.073-.315L29 9.707l.017-.189-.06.016a.538.538 0 0 0-.131-.336l.031-.09-.071.022a.53.53 0 0 0-.135-.337l.028-.069-.092-.016.037-.123-.068.024c-.014-.09-.043-.177-.07-.264l-.07.018.025-.134-.054.032c-.032-.142-.112-.265-.186-.387-.067-.123-.102-.271-.224-.352-.03-.111-.06-.24-.178-.286-.02-.11-.07-.211-.124-.308l-.05.136c-.015-.107.023-.253-.11-.296-.024-.068-.034-.15-.115-.173a.38.38 0 0 0-.173-.233c-.244-.418-.572-.786-.888-1.151-.203-.292-.49-.512-.73-.771-.166-.156-.308-.339-.505-.457l.02-.058-.085.042.02-.092-.098.025a.424.424 0 0 0-.164-.207.378.378 0 0 0-.187-.111.705.705 0 0 0-.343-.292 1.427 1.427 0 0 0-.466-.349c-.03-.075-.108-.09-.175-.112a.214.214 0 0 0-.15-.117l.014-.055-.103.028c.014-.115-.103-.11-.168-.148-.026-.08-.115-.085-.177-.115-.063-.104-.174-.147-.287-.169-.052-.073-.125-.123-.194-.175l-.04.028a.963.963 0 0 0-.467-.258c-.066-.116-.205-.145-.311-.21-.08-.036-.159-.074-.245-.079l.021-.067-.142.034.026-.087-.145.026.025-.094-.123.046-.014-.104-.095.048-.02-.079c-.098-.028-.196-.057-.296-.071l.023-.068-.12.036-.016-.069c-.096-.03-.192-.061-.292-.073l.017-.057-.185.02.016-.094-.09.026a.506.506 0 0 0-.222-.073l.018-.051-.196.014.034-.072c-.053.003-.157.01-.21.012l.033-.07-.197.012.003-.059-.146-.017a1.15 1.15 0 0 0-.274-.057l.038-.037c-.33-.027-.632-.204-.966-.186l.032-.057-.323.004.026-.058a20.824 20.824 0 0 1-.275-.01c-.141-.06-.296-.055-.445-.05l.023-.058a10.153 10.153 0 0 0-.497.004L16.58.07c-.254-.002-.51-.027-.762 0l-.109.09.071-.145a36.182 36.182 0 0 0-1.943-.002l.014.054c-.262.001-.536-.044-.788.046l-.388.012.013.058a6.86 6.86 0 0 0-.327-.005l.065.132c-.095-.103-.233-.065-.353-.077l.053.12c-.102-.066-.224-.06-.339-.069l.045.07a28.896 28.896 0 0 0-.316-.002l.013.048a.767.767 0 0 0-.275.063l-.193-.01.166.065c-.196-.006-.381.051-.574.07l.148.048c-.35-.025-.65.189-.986.245l.03.04a.555.555 0 0 0-.227.07L9.53.965l.024.09-.186-.01v.079l-.128-.04.025.07c-.1.012-.197.045-.292.076l-.017.065-.11-.03.003.088-.128-.03.017.086a9.98 9.98 0 0 0-.128-.026l.002.094-.129-.05.031.097a13.452 13.452 0 0 1-.149-.029l.025.062c-.088.022-.172.052-.258.08l.02.07a7.718 7.718 0 0 0-.108-.035l-.008.062-.14.058c-.096.032-.19.081-.24.173l-.169.046c-.131.108-.307.164-.414.3-.072.018-.15.03-.173.114-.07.022-.153.032-.175.115-.07.023-.149.037-.176.116-.073.017-.145.04-.173.117-.071.02-.14.046-.176.115a.365.365 0 0 0-.233.171.612.612 0 0 0-.244.168c-.18.082-.281.262-.449.36a.758.758 0 0 0-.294.317l-.092-.033.01.058c-.187.108-.322.279-.475.425-.185.196-.402.364-.548.593l-.065-.012.046.093a.785.785 0 0 0-.388.408c-.141.11-.276.235-.347.404a.46.46 0 0 0-.174.226.784.784 0 0 0-.123.154l-.049-.004.035.095c-.116-.014-.113.102-.15.17-.079.025-.092.104-.115.171-.063.032-.13.102-.118.166-.062.013-.104.118-.113.185-.081.023-.095.103-.122.169-.093.09-.143.21-.215.315l.026.043c-.126.055-.165.198-.208.316l-.06.017.03.093-.088.006.027.114H1.62c.006.03.017.091.024.121l-.088-.01.034.128-.085-.025c.006.035.015.106.02.142L1.44 8.41l.03.138-.09-.023.033.136-.091-.016.034.124a5.866 5.866 0 0 0-.1.008l.05.104-.07-.004c-.03.105-.065.208-.083.316l-.067-.029.038.121-.067.019c-.03.096-.064.19-.074.291l-.04-.032c-.03.105-.064.21-.076.32L.81 9.87l.015.19-.073-.031c.002.052.01.155.012.206a3.543 3.543 0 0 0-.072-.026l.015.198-.073-.018.018.19a3.032 3.032 0 0 0-.07-.02c0 .038-.004.113-.005.15-.053.083-.05.182-.057.276l-.058-.028.001.156c-.041.076-.055.162-.073.246a7.544 7.544 0 0 0-.06.232 2.832 2.832 0 0 0-.052.28c-.046.123-.043.257-.044.387a4.074 4.074 0 0 1-.065-.022l.015.307-.06-.003c-.004.162-.007.324-.005.486L.06 12.98c0 .189-.006.378.008.567l-.057-.042c-.021.785-.008 1.572-.008 2.359l.058-.053c-.004.21-.003.422.006.633l.124-.063c-.114.127-.065.304-.075.457l.066-.027c-.006.124-.007.25-.008.374l.063-.034c-.003.107-.004.216-.005.325l.062-.029c.025.11-.082.39.125.315-.122.06-.062.204-.019.299l.013.206h.042c.012.088.029.177.06.262l.014.158.045-.025c.011.146.05.288.077.432l.054-.026-.012.2.069-.03-.01.213.07-.037c-.002.053-.01.156-.013.209l.072-.034-.013.196.055-.02c.014.111.05.217.08.324l.038-.032c.011.072.026.143.044.215.067.157.098.33.202.47l-.029.088.069-.023c.017.1.047.198.076.296l.07.016-.035.114.09-.013a9.53 9.53 0 0 1-.034.138l.07-.021c.009.105.043.205.077.304l.065-.008-.04.131.072-.023c.008.099.042.193.072.288l.07.02-.036.093.1.026-.047.096.1.012a7.898 7.898 0 0 0-.042.126l.093-.03-.029.151.068-.03c.01.167.1.316.192.452l-.025.063.092.027-.03.088.086.027-.026.087.055.027.077.146-.024.062.093.025-.02.06a.84.84 0 0 1 .135.244l.054.11c.042.075.082.15.117.228.099.196.21.385.298.587l.055-.026-.03.121.095.009-.029.06c.077.099.102.25.226.305l.051.174c.115.144.135.375.304.464.027.153.089.324.228.41.02.074.044.148.07.223.045.067.09.14.162.184a.48.48 0 0 0 .12.253c.122.13.121.348.287.442.018.113.06.233.171.289.03.11.058.24.179.288.014.127.075.315.246.273-.135.1-.004.253.101.309.019.115.055.241.175.29.017.115.062.229.167.291.033.062.03.162.125.172.01.12.06.236.172.292.022.076.049.15.081.224l.071-.02-.037.069c.052.069.101.143.173.195a.99.99 0 0 0 .294.461c.056.169.152.344.286.462.017.078.033.166.136.167.006.186.143.346.27.47.021.072.031.157.12.177.015.114.064.228.168.288.029.064.033.155.12.173.02.07.033.157.12.176.019.077.046.152.077.225l.043-.03c.01.111.068.213.167.268.015.073.035.155.121.175.021.111.073.212.134.307l.038-.122c.008.102-.009.238.11.282.032.062.037.153.123.171.029.109.06.23.167.289.028.065.039.149.119.176.021.068.036.148.115.175.027.064.032.154.12.17.013.074.037.153.12.178.013.106.07.272.188.28-.09.051.041.152.105.181a.31.31 0 0 0 .197.294l-.039.084.065-.004c.047.107.105.211.164.314.037.05.08.092.132.128.04.176.158.335.285.462.024.067.034.152.12.17.01.076.04.152.12.176.016.178.165.296.245.447l.125-.014c-.134.078-.064.166.036.207a.532.532 0 0 0 .161.299c.03.062.058.131.123.166.06.124.104.274.236.343.015.072.032.153.116.177.019.071.03.155.12.175.018.114.065.224.166.291.028.063.038.147.118.17.031.062.03.155.117.175.015.076.05.171.127.177-.072.05.054.135.105.174.022.067.036.146.115.172.021.07.035.149.116.175.02.073.037.154.124.17.008.193.197.299.241.48l.055-.124c-.024.142.013.298.166.34.044.179.158.339.286.467.027.065.04.144.113.178.03.063.04.147.121.17.021.068.03.151.115.174.02.069.035.15.117.173.024.067.034.15.115.175.026.067.036.155.123.172.008.075.03.154.116.174a.197.197 0 0 0 .109.18c.086.24.325.445.595.387.12-.116.273-.218.318-.388.075-.035.107-.1.11-.178.082-.028.117-.095.107-.178.137-.017.116-.162.125-.26l.06.108.056-.19c.086-.022.1-.105.118-.177.09-.016.095-.104.118-.173.086-.02.095-.105.118-.173.08-.025.096-.103.116-.172.112-.038.105-.155.115-.252l.046.09.067-.145a.922.922 0 0 0 .125-.212c.074-.034.085-.116.114-.181a.954.954 0 0 0 .283-.46c.083-.023.103-.103.122-.174.076-.03.097-.106.116-.175.08-.025.09-.109.119-.173.076-.03.088-.111.117-.175.101-.065.144-.176.167-.288.079-.031.111-.096.116-.176a.981.981 0 0 0 .135-.125l.104-.221c.079-.029.091-.108.113-.176.056-.038.173-.12.115-.172.071-.015.112-.108.112-.184.082-.009.092-.098.132-.152.05-.054.082-.121.113-.186.13-.13.195-.307.287-.463.07-.036.103-.102.112-.178.085-.022.103-.101.115-.175.09-.018.096-.105.114-.176.084-.018.098-.102.12-.17.079-.027.092-.107.12-.174a1.01 1.01 0 0 0 .283-.464c.085-.021.107-.1.12-.174.083-.024.094-.106.117-.175.086-.02.095-.104.114-.174.082-.023.094-.107.121-.174.08-.025.086-.11.119-.172.058-.06.113-.126.166-.191l-.034-.074.067.02.08-.2.037.028c.029-.074.056-.147.082-.22.085-.025.098-.107.12-.178a.251.251 0 0 0 .106-.116c.091-.178.259-.314.296-.519.08-.026.103-.104.12-.176.111-.056.144-.178.171-.289.073-.037.117-.096.114-.179.086-.014.097-.098.125-.163.13-.117.2-.28.287-.428.087-.174.256-.306.288-.504.068-.04.226-.161.026-.205l.129.01c.098-.14.216-.274.252-.446.1-.043.13-.152.18-.238.044-.07.085-.144.116-.221a.205.205 0 0 0 .114-.173.557.557 0 0 0 .151-.193c.06-.133.173-.241.195-.39a.513.513 0 0 0 .13-.13c.087-.174.213-.328.279-.513.11-.056.148-.181.17-.294.127-.036.138-.18.178-.285a.416.416 0 0 0 .151-.19c.048-.104.112-.2.174-.295.082-.168.224-.31.25-.5.116-.05.16-.17.179-.286.069-.05.116-.12.163-.188.023-.074.046-.148.064-.222l.145-.106.028-.187c.104-.037.137-.148.19-.234.015-.056.03-.113.047-.169a.322.322 0 0 0 .17-.294c.147-.072.2-.255.235-.405.163-.114.229-.336.29-.518.104-.044.133-.162.184-.251.067-.162.172-.307.227-.475l.059-.009a10.35 10.35 0 0 1-.031-.108l.056.018c.046-.096.097-.191.148-.285.085-.208.234-.386.295-.604l.063-.008-.041-.1.094-.009-.03-.107.09-.02-.038-.095.09-.01-.026-.115.07.017.014-.329.066.21a7.95 7.95 0 0 0 .046-.253l.069.025a13.472 13.472 0 0 1-.03-.138l.085.014-.026-.128.09.005a4.4 4.4 0 0 0-.022-.076l.077-.151.055-.029-.032-.083.065-.018c.018-.07.043-.137.075-.201.068-.142.173-.275.176-.439l.065.027a18.446 18.446 0 0 0-.025-.144l.092.022-.042-.125.069.005c.026-.103.058-.205.077-.309l.068.034c-.01-.035-.026-.105-.035-.14l.096-.001-.023-.068c.027-.073.051-.147.073-.222l.071.019-.031-.093a.368.368 0 0 0 .072-.223l.066.025c-.005-.022-.012-.067-.016-.09.031-.07.055-.143.071-.22l.047.008-.012-.188.056.033c.023-.096.051-.191.08-.286.083-.26.217-.513.226-.79l.046.041c.03-.171.069-.341.073-.516l.06.122-.003-.185c.053-.103.05-.22.055-.332l.059.029c-.003-.095-.006-.19-.007-.284l.062.06-.005-.333.062.038-.003-.331.058.046c0-.13.002-.26.001-.39l.057.036c.001-.148.002-.295.001-.443l.059.037c0-.151 0-.303.004-.455.07-.202.053-.419.056-.63Z"/><g fill="#fff"><path d="M25.183 9.31c0 .447-.107.866-.323 1.257-.208.392-.539.707-.994.947-.447.24-1.014.359-1.7.359h-1.402v3.21h-1.677v-8.36h3.078c.647 0 1.198.111 1.653.335.455.224.794.531 1.018.922.232.392.347.835.347 1.33Zm-3.09 1.21c.463 0 .807-.104 1.03-.312.224-.216.336-.515.336-.898 0-.815-.456-1.222-1.366-1.222h-1.33v2.432h1.33ZM11.596 9.774a2.211 2.211 0 1 0-3.127-3.126 2.211 2.211 0 0 0 3.127 3.126ZM12.71 26.443a5.16 5.16 0 0 1-5.153-5.154c0-1.397.56-2.698 1.508-3.646l-.274-1.803A6.7 6.7 0 0 0 6 21.29c0 1.792.698 3.477 1.965 4.745A6.667 6.667 0 0 0 12.71 28a6.667 6.667 0 0 0 4.745-1.965c.383-.383.714-.803.989-1.253l-.686-2.45a5.162 5.162 0 0 1-5.047 4.111Z"/><path d="m22.11 24.944-1.487-5.312-.003-.01-.005-.018-.001-.003a1.697 1.697 0 0 0-.02-.063c0-.003 0-.005-.002-.007a1.51 1.51 0 0 0-.02-.057l-.005-.013a1.483 1.483 0 0 0-.02-.048l-.01-.02a1.295 1.295 0 0 0-.018-.038l-.015-.03-.015-.026-.02-.037-.012-.017a1.47 1.47 0 0 0-.067-.1l-.005-.006a1.477 1.477 0 0 0-.037-.048l-.003-.003a1.305 1.305 0 0 0-.041-.047l-.004-.005a1.697 1.697 0 0 0-.041-.043l-.008-.008a1.092 1.092 0 0 0-.04-.037l-.013-.012a1.15 1.15 0 0 0-.035-.03l-.022-.018-.029-.023a1.06 1.06 0 0 0-.052-.038l-.04-.026-.014-.01a2.043 2.043 0 0 0-.048-.027l-.008-.005a1.607 1.607 0 0 0-.054-.029l-.005-.002a1.4 1.4 0 0 0-.056-.027l-.004-.002a1.492 1.492 0 0 0-.057-.024l-.006-.002a1.684 1.684 0 0 0-.055-.02l-.01-.003a1.396 1.396 0 0 0-.05-.015l-.019-.006a1.832 1.832 0 0 0-.143-.03l-.024-.005a1.726 1.726 0 0 0-.05-.006l-.015-.002a1.466 1.466 0 0 0-.06-.004h-.008a1.53 1.53 0 0 0-.064-.002h-5.927l-.161-1.059h4.527a1.09 1.09 0 1 0 0-2.18H12.85l-.47-3.091a1.713 1.713 0 0 0-3.387.515l1.09 7.162a1.713 1.713 0 0 0 1.691 1.456h6.429l1.208 4.316a1.402 1.402 0 0 0 2.698-.755Z"/></g></svg>
		`));

		setupGoogleMap();
		getLocationByGeo();
		setupEventListeners();
	};

	const getData = async () => {
		const regionCountyDataUrl = document.querySelector('#bb-json').getAttribute('data-json-path');

		try {
			const rcd = await fetch(regionCountyDataUrl);
			const regionCountyData = await rcd.json();
			return regionCountyData;
		} catch (error) {
			console.error('Error fetching region county data:', error);
			return null;
		}
	};

	const setupEventListeners = () => {
		// setup click handlers for the postcode input, geolocation button & get results button
		postcode.addEventListener('keypress', e => {
			sInputKeyValidationHelper(postcode, 'alphaNumeric', fieldGroup);
			if (e.key === 'Enter') {
				e.preventDefault();
				const postcodeValue = postcode.value.trim();
				getLocationByPostcode(postcodeValue);
			}
		});

		postcode.addEventListener('focusout', () => {
			postCodeValid = false;
			const postcodeValue = postcode.value.trim();
			fieldGroup.classList.remove('field-group--error');

			// Check if the postcode is valid using the imported function
			// and the error messages from the CMS
			const { isValid, errorMessage } = sIsValidPostcode(postcodeValue, postCodeErrors);
			if (!isValid) {
				fieldGroup.classList.add('field-group--error');
				errorMessageElement.innerHTML = errorMessage;
			} else {
				postCodeValid = true;
				errorMessageElement.innerHTML = '';
			}
		});

		searchHereButton.addEventListener('click', event => {
			event.preventDefault();
			removeErrorMessage();
			infoElement.classList.remove('blue-badge__details-drawer--open');

			const newLocation = mapElement.getCenter();
			const newLat = newLocation.lat();
			const newLng = newLocation.lng();

			const geoLocation = { lat: newLat, lng: newLng };
			searchHereElement.classList.add('blue-badge__search-here--hidden');
			getPostcodeFromGeoLocation(geoLocation);
		});

		geoLocate.addEventListener('click', e => {
			e.preventDefault();
			getLocationByGeo();
			updateResultsSection(currentLocationData);
		});

		getResultsButton.addEventListener('click', async e => {
			e.preventDefault();
			removeErrorMessage();
			if (!postCodeValid) {
				fieldGroup.classList.add('field-group--error');
				errorMessageElement.innerHTML = postCodeErrors.empty;
				return;
			}
			const postcodeValue = postcode.value.trim();
			getLocationByPostcode(postcodeValue);
		});

		changePostcode.addEventListener('click', e => {
			e.preventDefault();
			closeInfoWindow();
			scrollToPostCodeInput();
		});

		closeInfo.addEventListener('click', e => {
			e.preventDefault();
			closeInfoWindow();
		});
	};

	const showErrorMessage = message => {
		fieldGroup.classList.add('field-group--error');
		errorMessageElement.innerHTML = message;
	};

	const removeErrorMessage = () => {
		fieldGroup.classList.remove('field-group--error');
		errorMessageElement.innerHTML = '';
	};

	// IF WE ARE LOCATING BY GEO LOCATION WE NEED TO CONVERT IN TO POST CODE TO SEACH THE API
	const getPostcodeFromGeoLocation = async geoLocation => {
		const geocoder = new google.maps.Geocoder();

		let selectedPostCodeValue;
		try {
			const response = await geocoder.geocode({ location: geoLocation });
			if (response.results[0]) {
				response.results[0].address_components.forEach(function (part, i) {
					if (part.types[0] === 'postal_code') {
						postcode.value = part.short_name;
						selectedPostCodeValue = part.short_name;
					}
				});

				getLocationByPostcode(selectedPostCodeValue);
			} else {
				errorValidation((geoLocationError = true));
				showErrorMessage('No results found');
				throw new Error('No results found');
			}
		} catch (error) {
			console.warn(`Geocoder failed due to: ${error}`);
			showErrorMessage(error);
			errorValidation((geoLocationError = true));
		}
	};

	const getLocationByGeo = async () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				// ---- SUCCESS CALLBACK ---- //
				async position => {
					const lat = position.coords.latitude;
					const lng = position.coords.longitude;

					try {
						const response = await fetch(`https://api.postcodes.io/postcodes?lon=${lng}&lat=${lat}`);

						if (!response.ok) {
							throw new Error(`HTTP error fetching postcode! Status: ${response.status}`);
						}

						const data = await response.json();

						if (data.status === 200 && data.result && data.result.length > 0) {
							const currentPostcode = data.result[0].postcode;
							postcode.value = currentPostcode;
							postCodeValid = true; // Set the postcode as valid
							fieldGroup.classList.remove('field-group--error'); // Remove error class
							errorMessageElement.innerHTML = ''; // Clear any error message

							// Storing the first result object.
							currentLocationData = data.result[0];

							updateMap(currentLocationData);
							updateResultsSection(currentLocationData);
							findDisabledParkingWithTextSearch();
						} else {
							// Handle cases where API gives 200 but no results, or other API errors
							const errorMessage = data.error || 'No postcodes were found for this location.';
							console.warn('Postcode lookup warning:', errorMessage, data);
							showErrorMessage('No postcodes were found for this location.');
							// clearing currentLocationData if lookup fails
							currentLocationData = null;
						}
					} catch (error) {
						// Handle network errors or other issues with the fetch call
						console.error('Error fetching postcode via coordinates:', error);
						// clearing currentLocationData if lookup fails
						currentLocationData = null;
						showErrorMessage('No postcodes were found for this location.');
						throw new Error(`Failed to retrieve postcode: ${error.message}`);
					}
				},

				// ERROR CALLBACK (FOR GETCURRENTPOSITION)  //
				error => {
					console.error('Geolocation error:', error);
					let message = 'Geolocation error: ';
					switch (error.code) {
						case error.PERMISSION_DENIED:
							message += 'User denied the request for Geolocation.';
							break;
						case error.POSITION_UNAVAILABLE:
							message += 'Location information is unavailable.';
							break;
						case error.TIMEOUT:
							message += 'The request to get user location timed out.';
							break;
						case error.UNKNOWN_ERROR:
							message += 'An unknown error occurred.';
							break;
					}
					console.error(message);
					// CLEARING CURRENTLOCATIONDATA IF GEOLOCATION FAILS
					currentLocationData = null;
				}
			);
		} else {
			console.error('Geolocation is not supported by this browser.');
			showErrorMessage('Geolocation is not supported by this browser.');
		}
	};

	const getLocationByPostcode = async postcodeValue => {
		if (postcodeValue.length > 0) {
			try {
				const response = await fetch(`https://api.postcodes.io/postcodes/${postcodeValue}`);
				if (!response.ok) {
					if (response.status === 404) {
						throw new Error(`Postcode '${postcodeValue}' not found.`);
					}
					throw new Error(`HTTP error! Status: ${response.status}`);
				}

				const data = await response.json();

				// NOTE: POSTCODES.IO RETURNS STATUS 200 EVEN FOR INVALID POSTCODES,
				// BUT THE 'RESULT' FIELD WILL BE NULL OR MISSING.
				// IT'S OFTEN BETTER TO CHECK FOR THE PRESENCE OF THE EXPECTED DATA ('RESULT').

				if (data.status === 200 && data.result) {
					currentLocationData = data.result; // Store the first result object
					updateMap(currentLocationData);
					updateResultsSection(currentLocationData);
					findDisabledParkingWithTextSearch();
				} else {
					// Handle API-level errors (e.g., valid request, but postcode invalid)
					const errorMessage = data.error || `Unable to get results for the postcode '${postcodeValue}'.`;
					console.warn('API Error:', errorMessage, data);
					console.error(errorMessage);
				}
			} catch (error) {
				// Catch network errors or errors thrown above
				console.error('Error fetching postcode details:', error);
				console.error(`Error fetching postcode details: ${error.message}`);
				showErrorMessage(`${error.message}`);
			}
		} else {
			console.error('Please enter a postcode.');
			showErrorMessage(`Please enter a postcode.`);
		}
	};

	const setupGoogleMap = async () => {
		const { Map } = await google.maps.importLibrary('maps');

		mapElement = new Map(document.getElementById('map'), {
			center: { lat: 51.5074575, lng: -0.1281918 },
			zoom: 4,
			mapId: 'b19f8104abf2594f',
			disableDefaultUI: true,
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT, // POSITION OF THE ZOOM CONTROL AWAR FROM DRAG SEARCH OVERLAY
			},
		});

		google.maps.event.addListenerOnce(mapElement, 'idle', () => {
			// CHECK MAP IS FULLY LOADED AND IDLE
			findDisabledParkingWithTextSearch();
		});

		mapElement.addListener('drag', draggedSearchHere);
	};

	const draggedSearchHere = () => {
		searchHereElement.classList.remove('blue-badge__search-here--hidden');
	};

	const updateMap = async currentLocationData => {
		const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

		if (currentLocationData) {
			const lat = currentLocationData.latitude;
			const lng = currentLocationData.longitude;
			const postcode = currentLocationData.postcode;

			mapElement.setCenter({ lat, lng });
			mapElement.setZoom(14); // Adjust zoom level as needed

			currentLocationMarker = new AdvancedMarkerElement({
				map: mapElement,
				position: { lat, lng },
				title: `Postcode: ${postcode}`,
			});
		} else {
			console.error('No location data available to update the map.');
		}
	};

	const findDisabledParkingWithTextSearch = async () => {
		let Place, AdvancedMarkerElement, LatLngBounds;
		try {
			[Place, AdvancedMarkerElement, LatLngBounds] = await Promise.all([
				google.maps.importLibrary('places'),
				google.maps.importLibrary('marker'),
				google.maps.importLibrary('core'),
			]).then(libs => [libs[0].Place, libs[1].AdvancedMarkerElement, libs[2].LatLngBounds]);
		} catch (error) {
			console.error('Error importing Google Maps libraries:', error);
			return;
		}

		if (!mapElement) {
			/*  MAP CHECK  */ return;
		}
		const center = mapElement.getCenter();
		if (!center) {
			/* CENTER CHECK */ return;
		}

		const request = {
			textQuery: 'disabled parking',
			// REQUEST FIELDS NEEDED INITIALLY AND FOR POTENTIAL POST-FILTERING
			fields: [
				'id',
				'location',
				'displayName',
				'types',
				'primaryType',
				'formattedAddress',
				'accessibilityOptions',
			],
			locationBias: {
				center: center,
				radius: 2000,
			},
			maxResultCount: 20,
			language: 'en-GB',
			region: 'uk',
		};

		try {
			const { places } = await Place.searchByText(request);

			if (!places || places.length === 0) {
				deleteMarkers();
				return;
			}

			deleteMarkers();

			const bounds = new LatLngBounds();

			const detailPromises = places.map(async place => {
				if (!place.id || !place.location) {
					console.warn(`Skipping place with missing ID/location (Name: ${place.displayName})`);
					return null;
				}
				try {
					await place.fetchFields({
						fields: ['accessibilityOptions', 'formattedAddress', 'addressComponents'],
					});
					return place;
				} catch (fetchError) {
					console.error(`Error fetching details for ${place.displayName || place.id}:`, fetchError);
					return place; // Return basic place on error
				}
			});

			const placesWithDetails = (await Promise.all(detailPromises)).filter(p => p !== null);

			let markersAdded = 0;

			for (const place of placesWithDetails) {
				if (!place.location) continue;

				let markerTitle = place.displayName || `Place ID: ${place.id}`;
				let accessibilityParkingInfo = 'Accessibility info not available or fetch failed.';
				let accessibilityEntranceInfo = 'Accessibility info not available or fetch failed.';
				let hasAccessibleParking = false;
				let hasAccessibleEntrance = false;

				if (place.accessibilityOptions) {
					if (place.accessibilityOptions.hasWheelchairAccessibleParking === true) {
						hasAccessibleParking = true;
						markerTitle += ' (Accessible Parking)';
						accessibilityParkingInfo = 'Wheelchair accessible parking.';
						hasAccessibleEntrance = place.accessibilityOptions.hasWheelchairAccessibleEntrance
							? true
							: false;
						if (hasAccessibleEntrance) {
							accessibilityEntranceInfo = 'Wheelchair accessible entrance.';
							markerTitle += ' (Wheelchair accessible Entrance)';
						}
					} else if (place.accessibilityOptions.hasWheelchairAccessibleParking === false) {
						accessibilityParkingInfo = 'NO wheelchair accessible parking.';
						markerTitle += ' (No Accessible Parking Reported)';
						hasAccessibleEntrance = place.accessibilityOptions.hasWheelchairAccessibleEntrance
							? true
							: false;
						if (hasAccessibleEntrance) {
							accessibilityEntranceInfo = 'Wheelchair accessible entrance.';
							markerTitle += ' (Wheelchair accessible Entrance)';
						}
					} else {
						accessibilityParkingInfo = 'Wheelchair accessible parking status unknown.';
					}
				}

				const marker = await createMarker(place, markerTitle, hasAccessibleParking);
				// PROCESS THE CREATED MARKER (IF SUCCESSFUL)
				if (marker) {
					markers.push(marker);
					markersAdded++;
					bounds.extend(place.location); // EXTEND MAP BOUNDS

					marker.addListener('gmp-click', () => {
						displayPlaceInfoNew(place, accessibilityParkingInfo, accessibilityEntranceInfo);
					});
				}
			}
		} catch (error) {
			// CATCH ERRORS FROM PLACE.SEARCHBYTEXT ITSELF
			console.error('Error during Place.searchByText execution:', error);
			if (error instanceof TypeError) {
				console.error('Potential issue with library loading or method call signature.');
			} else if (error.code) {
				console.error(`API Error Code: ${error.code}, Message: ${error.message}`);
			}
		}
	};

	const createMarker = async (place, title) => {
		if (!place.location) {
			return null;
		}

		const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

		try {
			// CREATE CONTAINER DIV FOR SVG
			const markerContentDiv = document.createElement('div');
			markerContentDiv.style.width = '30px';
			markerContentDiv.style.height = '43px';
			markerContentDiv.style.display = 'flex';
			markerContentDiv.style.alignItems = 'center';
			markerContentDiv.style.justifyContent = 'center';
			markerContentDiv.style.overflow = 'hidden';
			markerContentDiv.style.boxSizing = 'border-box';

			// Set SVG as innerHTML of the container
			markerContentDiv.innerHTML = parkingSvgString;

			const marker = new AdvancedMarkerElement({
				map: mapElement,
				position: place.location,
				title: title,
				content: markerContentDiv,
			});

			return marker;
		} catch (markerError) {
			console.error(
				`Error during AdvancedMarkerElement creation for ${place.displayName || place.id}:`,
				markerError
			);
			return null;
		}
	};

	const deleteMarkers = () => {
		for (let i = 0; i < markers.length; i++) {
			markers[i].map = null;
		}
		markers = [];
	};

	const displayPlaceInfoNew = (place, accessibilityParkingInfo, accessibilityEntranceInfo) => {
		if (!place || !place.location) {
			console.error('Invalid place data:', place);
			return;
		}

		const formattedAddress = formatAddressComponents(place.addressComponents);

		if (infoContents) {
			infoContents.innerHTML = `
				<h3 class="display-1">${place.displayName || 'Unknown Place'}</h3>
				<p>${formattedAddress || 'Address not available'}</p>
				<ul class="blue-badge__details--parking-list">
					<li>
						<span class="blue-badge__details--parking-icon">${parkingSvgString}</span>
						<strong> ${accessibilityParkingInfo}</strong>
					</li>
					<li>
						<span class="blue-badge__details--parking-icon">${parkingSvgString}</span>
						<strong>${accessibilityEntranceInfo}</strong>
					</li>
				</ul>
			`;
			infoContents.style.display = 'block';
			infoElement.classList.add('blue-badge__details-drawer--open');
		}
	};

	// FORMAT ADDRESS RETURNED FROM GOOGLE PLACES
	const formatAddressComponents = (addressComponents, includeCountry = false) => {
		if (!addressComponents || !Array.isArray(addressComponents)) return 'Address not viable';

		if (!addressComponents?.length) return 'Address not available';

		const parts = addressComponents.reduce(
			(acc, component) => {
				const value = component.longText || component.shortText || component.text || ''; // FALLBACK TO EMPTY STRING IF NO TEXT FOUND
				const types = component.types;

				// ASSIGN USING DESCRIPTIVE KEYS
				if (types.includes('premise')) acc.premise = value;
				else if (types.includes('street_number')) acc.streetNumber = value;
				else if (types.includes('route')) acc.route = value;
				else if (types.includes('postal_town')) acc.postalTown = value;
				// CAPTURE LOCALITY ONLY IF POSTAL_TOWN HASN'T BEEN FOUND YET
				else if (types.includes('locality') && !acc.postalTown) acc.localityFallback = value;
				else if (types.includes('administrative_area_level_2')) acc.county = value;
				else if (types.includes('postal_code')) acc.postcode = value?.toUpperCase();
				else if (types.includes('country')) acc.country = value === 'GB' ? 'United Kingdom' : value;
				return acc;
			},
			{
				// INITIAL ACCUMULATOR WITH DEFAULT EMPTY STRINGS
				premise: '',
				streetNumber: '',
				route: '',
				postalTown: '',
				localityFallback: '',
				county: '',
				postcode: '',
				country: '',
			}
		);

		// DETERMINE THE TOWN (POSTAL TOWN PREFERRED, FALLBACK TO LOCALITY)
		const town = parts.postalTown || parts.localityFallback;

		// BUILD AND FILTER ADDRESS LINES DIRECTLY USING READABLE PARTS OBJECT
		return [
			// PREMISE OR STREET NUMBER + ROUTE
			parts.premise ||
				`${parts.streetNumber || ''} ${parts.route != 'Unnamed Road' ? parts.route : '' || ''}`.trim(),
			// POSTAL TOWN / LOCALITY
			town,
			// COUNTY (ONLY IF PRESENT AND DIFFERENT FROM TOWN)
			parts.county && parts.county !== town ? parts.county : null,
			// POSTCODE
			parts.postcode,
			// COUNTRY (ONLY IF REQUESTED AND IS UK)
			includeCountry && parts.country === 'United Kingdom' ? parts.country : null,
		]
			.filter(Boolean) // REMOVE NULL, UNDEFINED, OR EMPTY STRINGS FROM THE ARRAY
			.join('<br>');
	};

	const closeInfoWindow = () => {
		infoElement.classList.remove('blue-badge__details-drawer--open');
		// CLEAR THE CONTENT WHEN CLOSING
		infoContents.innerHTML = '';
	};

	const updateResultsSection = async currentLocationData => {
		results.classList.remove('display-none');
		if (currentLocationMarker) {
			// REMOVE THE MARKER FROM THE MAP
			currentLocationMarker.map = null;
		}
		if (currentLocationData) {
			const postCode = currentLocationData.postcode;
			postCodeLookupUrl = document.querySelector('#blueBadge').getAttribute('data-postCodeLookupUrl');

			const regionLookup = await fetch(`${postCodeLookupUrl}/${postCode}`);

			const regionData = await regionLookup.json();
			const regionFromPostCode = regionData.region || 'Region not found';

			results.querySelector('.blue-badge__results-postcode').innerHTML = postCode;
			results.querySelector('.blue-badge__results-authority').innerHTML = regionFromPostCode;

			await getCountyResultsData(regionFromPostCode, regionData);

			// HIDE THE GRAPH IF THERE ARE NO SPACES OR HOLDERS
			if (completeData) {
				results.classList.remove('display-none');
			} else {
				results.classList.add('display-none');
			}

			graphLabelSpaces.innerHTML = totalSpaces;
			graphLabelHolders.innerHTML = totalHolders;

			// SET GRAPH BAR STYLE TO BE PERCENTAGE WIDTH OF TOTALSPACES AND TOTALHOLDERS
			const spacesPercentage = totalSpaces > 0 ? (totalSpaces / (totalSpaces + totalHolders)) * 100 : 0;
			const holdersPercentage = totalHolders > 0 ? (totalHolders / (totalSpaces + totalHolders)) * 100 : 0;
			graphBarSpaces.style.width = `${spacesPercentage}%`;
			graphBarHolders.style.width = `${holdersPercentage}%`;

			if (totalSpaces < totalHolders) {
				graphDifference.innerHTML = `There are <b>${totalHolders - totalSpaces} more</b> blue badge holders than available spaces`;
			} else {
				graphDifference.innerHTML = `There are <b>${totalSpaces - totalHolders} more</b> available spaces than blue badge holders`;
			}
		}
	};

	const getCountyResultsData = async (regionFromPostCode, regionData = {}) => {
		const regionCountyData = await getData();

		if (!regionCountyData) {
			console.error('Failed to fetch or parse region county data.');
			totalSpaces = 0;
			totalHolders = 0;
			return [totalSpaces, totalHolders];
		}

		// LOOK FOR AN EXACT REGION MATCH
		if (regionCountyData.hasOwnProperty(regionFromPostCode)) {
			const countiesObj = regionCountyData[regionFromPostCode];

			// reset before summing
			totalSpaces = 0;
			totalHolders = 0;
			completeData = true;

			// LOOP THROUGH EACH COUNTY IN THE REGION
			for (const countyName in countiesObj) {
				const county = countiesObj[countyName];

				if (county.num_spaces === undefined || county.num_holders === undefined) {
					completeData = false;
				}

				totalSpaces += county.num_spaces || 0;
				totalHolders += county.num_holders || 0;
			}

			return [totalSpaces, totalHolders];
		}

		// FALL BACK TO THE COUNTRY IF SUPPLIED
		if (regionData.country && regionCountyData.hasOwnProperty(regionData.country)) {
			const { num_spaces = 0, num_holders = 0 } = regionCountyData[regionData.country];
			if (num_spaces === undefined || num_holders === undefined) {
				completeData = false;
			}
			totalSpaces = num_spaces;
			totalHolders = num_holders;
			return [totalSpaces, totalHolders];
		}

		console.warn('No matching region or country found in the data.');
		return [0, 0];
	};

	const scrollToPostCodeInput = () => {
		postcode.scrollIntoView({ behavior: 'smooth', block: 'center' });
	};

	// Return the init function
	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', () => {
	bluebadges.init();
});
